export type IconProps = React.SVGProps<SVGSVGElement>;

const ChevronDownIcon = ({ className, ...props }: IconProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      role="img"
      className={className}
      {...props}
    >
      <path
        d="M16 8L10 14L4 8"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ChevronDownIcon;
